(function () {
  const megeNavSiderBar = document.querySelectorAll(
    ".js-mega-nav .mega-nav--sidebar"
  );
  if (window.innerWidth > 768) {
    megeNavSiderBar.forEach((item) => {
      // copy real product list
      const productTempWrap = item.querySelector(".pc-real-product-list");
      const productTemp = item.querySelectorAll(".disclosure__panel");
      productTemp.forEach((item) => {
        productTempWrap.appendChild(item.cloneNode(true));
      });
      const copyedProduct = item.querySelectorAll(
        ".pc-real-product-list .disclosure__panel"
      );
      if (copyedProduct[0]) {
        copyedProduct[0].classList.add("active");
      }
    });
  }

  const navOpenBtns = document.querySelectorAll(".nav-item");
  navOpenBtns.forEach((navItem) => {
    if (navItem.querySelector(".nav-item-action")) {
      navItem
        .querySelector(".nav-item-action")
        .addEventListener("click", () => {
          if (navItem.classList.contains("active")) {
            navItem.classList.remove("active");
          } else {
            navOpenBtns.forEach((navItem) => {
              navItem.classList.remove("active");
            });
            navItem.classList.add("active");
          }
        });
    }
  });

  const navList = document.querySelectorAll(".js-mega-nav .mega-nav--sidebar");
  navList.forEach((item, navItemIndex) => {
    const subNavListWrap = item.querySelectorAll(
      ".child-nav__item--toggle.main-nav__item--toggle"
    );
    const allProductListWrap = item.querySelector(".pc-real-product-list");
    const subNavContentList = item.querySelectorAll(
      ".disclosure__panel .nav-item"
    );
    const allProductList2 = document.querySelectorAll(
      ".pc-real-product-list .disclosure__panel .nav-item"
    );
    const subNavContentList2 = item.querySelectorAll(
      ".pc-real-product-list .disclosure__panel"
    );

    subNavListWrap.forEach((subNavListWrapItem, subNavListWrapIndex) => {
      const subNavList = subNavListWrapItem.querySelectorAll(
        ".nav-submenu .nav-item"
      );
      subNavList.forEach((subItem, subItemIndex) => {
        subItem.addEventListener("mouseenter", () => {
          subNavList.forEach((subItem2) => {
            if (subItem2 !== subItem) {
              subItem2.classList.remove("active");
            } else {
              subItem.classList.add("active");
            }
          });

          subNavContentList.forEach((subContent, subContentIndex) => {
            if (subItemIndex === subContentIndex) {
              subContent.classList.add("active");
            } else {
              subContent.classList.remove("active");
            }
          });

          // pc real nav items
          allProductListWrap.scrollTop = 0;
          subNavContentList2[subNavListWrapIndex]
            .querySelectorAll(".nav-item")
            .forEach((subContent, subContentIndex) => {
              if (subItemIndex === subContentIndex) {
                subContent.classList.add("active");
              } else {
                subContent.classList.remove("active");
              }
            });
        });
      });

      subNavListWrapItem.addEventListener("mouseenter", () => {
        if (false) {
          return;
        } else {
          subNavContentList.forEach((item2) => {
            item2.classList.remove("active");
          });
          const subNavList = subNavListWrapItem.querySelectorAll(".nav-submenu .nav-item");
          subNavList.forEach((subItem, subItemIndex) => {
            if (subItemIndex === 0) {
              subItem.classList.add("active");
            } else {
              subItem.classList.remove("active");
            }
          });
          subNavContentList.forEach((subContentItem, subContentItemIndex) => {
            if (subContentItemIndex === 0) {
              subContentItem.classList.add("active");
            } else {
              subContentItem.classList.remove("active");
            }
          });
  
          // pc real nav items
          allProductList2.forEach((item2) => {
            item2.classList.remove("active");
          });
          subNavContentList2.forEach((subContentItem, subContentItemIndex) => {
            if (subContentItemIndex === subNavListWrapIndex) {
              subContentItem.classList.add("active");
              subContentItem
                .querySelectorAll(".nav-item")[0]
                .classList.add("active");
            } else {
              subContentItem.classList.remove("active");
            }
          });
        }
      });
    });
  });
})();
